module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "home-page-hot-offers"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content og-bg-dark"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('message.title.site.hot_offers')))])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hotCars.length === 0),
      expression: "hotCars.length === 0"
    }],
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content og-bg-light"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.text.cars.no_cars')) + "\n      ")])], 1), _vm._v(" "), _vm._l((_vm.hotCars), function(car) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hotCars.length > 0),
        expression: "hotCars.length > 0"
      }],
      staticClass: "row"
    }, [_c('clearfix', {
      attrs: {
        "wide": true
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 content og-bg-light"
    }, [_c('h4', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Car',
          params: {
            id: car.id
          }
        }
      }
    }, [_vm._v(_vm._s(car.brand) + " " + _vm._s(car.model) + " (" + _vm._s(car.year) + ")")])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (car.photos.length > 0),
        expression: "car.photos.length > 0"
      }],
      staticClass: "car-photo",
      style: ({
        backgroundImage: 'url(\'' + _vm.$t(_vm.imageBase, {
          car_id: car.id,
          file_name: _vm.getPhotoFileName(car.photos)
        }) + '\')',
        width: '300px',
        height: '200px'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "car-description",
      domProps: {
        "innerHTML": _vm._s(car.description)
      }
    })])], 1)
  }), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d215fc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/car/HotOffers.vue
// module id = 1217
// module chunks = 1